import React, { Component } from 'react';
import { Chip, Grid, Table, TableBody, TableCell as TC, TableRow, withStyles } from '@material-ui/core';

// import FacultyDetail from '../faculty/FacultyDetail';
import { FACULTY_API_URL, EVENT_ID, PROGRAM_API_URL, groupBy } from '../constants';
import PgmVodDialog from '../components/dialogs/PgmVodDialog';
import MainContext from '../MainContext';
import MainProvider from '../MainProvider';

import moment from 'moment';
import axios from 'axios';
import FacultyDetail from '../faculty/FacultyDetail';

const styles = (theme) => ({
  liveDiv: {
    padding: 20,
    backgroundColor: '#fafafa',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      // padding: theme.spacing(5),
    },
  },
  container: {
    backgroundColor: '#fafafa',
    width: '100%',
  },
  detailWrap: {
    padding: '8vh 10vw',
    // padding: theme.spacing(8, 18),
    [theme.breakpoints.down('sm')]: {
      padding: '8vh 0',
      margin: '0 10vw',
      '& > div': {
        overflow: 'auto',
      },
    },
  },
  isLiveTitle: {
    color: theme.palette.primary.main,
    fontWeight: 600,
    fontSize: '1.5em',
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    paddingLeft: '1em',
    marginBottom: '0.5em',
  },
  titleVodDiv: {
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sessionTitle: {
    fontSize: '1.3em',
    fontWeight: 600,
    color: theme.palette.primary.point,
    marginBottom: '0.5em',
    [theme.breakpoints.down('sm')]: {
      display: 'inline',
    },
  },
  subtitle: {
    fontSize: '1.2em',
    fontWeight: 600,
    marginBottom: '0.5em',
  },
  programTime: {
    color: theme.palette.primary.point,
    fontWeight: 500,
    marginBottom: '0.5em',
  },
  programPlace: {
    color: '#FF752D',
    fontWeight: 500,
    marginBottom: '0.5em',
  },
  panelListTitle: {
    whiteSpace: 'pre',
    fontWeight: 'bold',
  },
  panelName: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },

  speakerTable: {
    borderTop: `2px solid #009cde`,
  },
  table: {
    marginTop: '1em',
    borderTopWidth: '4px',
    borderTopStyle: 'solid',
    borderTopColor: theme.palette.primary.main,
    '& thead th:not(:last-child) > div': {
      borderRight: '1px solid rgba(0, 0, 0, 0.1)',
    },
    '& thead th:last-child > div': {
      textAlign: 'start',
      paddingLeft: '2em',
    },
  },
  tableBody: {
    '& tr th:first-child, & tr td:first-child': {
      textAlign: 'center',
    },
    '& th': {
      fontWeight: 'bold',
      backgroundColor: '#e8f2f7',
      color: '#232323',
      '&:first-of-type': {
        width: '20%',
      },
      '&:last-of-type': {
        width: '80%',
      },
    },
    '& td': {
      backgroundColor: '#fff',
      color: '#555',
      '&:first-of-type': {
        width: '20%',
      },
    },
  },
});

const TableCell = withStyles((theme) => ({
  head: {
    fontWeight: 'bold',
    backgroundColor: '#e8f2f7',
    color: '#232323',
  },
  body: {
    backgroundColor: '#fff',
    color: '#555',
  },
  root: {
    // textAlign: 'center',
    padding: 0,
    '& > div': {
      margin: theme.spacing(1.5, 0),
      [theme.breakpoints.down('sm')]: {
        margin: theme.spacing(1.5, 2),
      },
    },
    '&:first-of-type': {
      width: '20%',
    },
  },
}))(({ children, classes, ...props }) => (
  <TC
    classes={{
      root: classes.root,
      head: classes.head,
      body: classes.body,
    }}
    {...props}
  >
    {children}
  </TC>
));

class ProgramDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFacultyDialogOpen: false,
      isVodDialogOpen: false,
      facultyInfo: null,
      vodId: '',
      pgmDetail: null,
      matches: window.matchMedia('(max-width:1280px)').matches,
    };
  }

  componentDidMount() {
    const { isLive, program } = this.props;

    if (isLive) this.getDetail(program.id);
    // if (isLive) this.getDetail(sessionStorage.getItem('_in_session'));
  }

  closeFacultyDialog() {
    this.setState({ isFacultyDialogOpen: false });
  }

  openVODDialog(item, vod) {
    const vodId = vod ? vod : item.vod;
    this.setState({ vodId: vodId.replace(/ /gi, ''), isVodDialogOpen: true });
  }

  //프로그램 상세정보 받아오는 function
  getDetail(id) {
    axios.get(`${PROGRAM_API_URL}/program/detail?eventId=${EVENT_ID}&pgmId=${id}`, { headers: { Pragma: 'no-cache' } }).then((response) => {
      response.data.sort((a, b) => {
        const ao = a.order ? Number(a.order) : 0;
        const bo = b.order ? Number(b.order) : 0;
        return ao < bo ? -1 : 0;
      });
      if (response.data) {
        // console.log()
        this.setState({ pgmDetail: response.data });
      }
    });
  }

  getFacultyData(id) {
    if (id) {
      axios
        .get(`${FACULTY_API_URL}/faculty/info?eventId=${EVENT_ID}&id=${EVENT_ID}_${id}`)
        .then((response) => {
          if (response.data && response.data.Item) {
            this.setState({ facultyInfo: response.data.Item, isFacultyDialogOpen: true });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  renderLive() {
    const { classes } = this.props;

    return (
      <MainProvider>
        <MainContext.Consumer>
          {(value) => {
            const chIdx =
              value.arrCurrentSesseion.length > 0 ? value.arrCurrentSesseion.findIndex((p) => p.channel === this.props.channelId) : 0;
            return (
              <div className={classes.liveDiv}>
                <div className={classes.isLiveTitle}>
                  {value.arrCurrentSesseion[chIdx] &&
                    value.arrCurrentSesseion[chIdx]['pgTitle'] &&
                    value.arrCurrentSesseion[chIdx]['pgTitle']}
                </div>
                {value.arrCurrentSesseion[chIdx] && (
                  <>
                    <div>
                      {/*<div className={classes.titleVodDiv}>*/}
                      {/*  {value.arrCurrentSesseion[chIdx]['pgTitle'] && (*/}
                      {/*    <p className={classes.sessionTitle}>{value.arrCurrentSesseion[chIdx]['pgTitle']}</p>*/}
                      {/*  )}*/}
                      {/*  {value.arrCurrentSesseion[chIdx]['vod'] && (*/}
                      {/*    <Chip*/}
                      {/*      size="small"*/}
                      {/*      label="VOD"*/}
                      {/*      style={{ backgroundColor: '#9ccc65', color: 'white', fontSize: '1em', marginLeft: '1em' }}*/}
                      {/*      onClick={() => {*/}
                      {/*        this.openVODDialog(value.arrCurrentSesseion[chIdx]);*/}
                      {/*      }}*/}
                      {/*    />*/}
                      {/*  )}*/}
                      {/*</div>*/}
                      {value.arrCurrentSesseion[chIdx]['pgSub'] && (
                        <p className={classes.subtitle}>{value.arrCurrentSesseion[chIdx]['pgSub']}</p>
                      )}
                      {value.arrCurrentSesseion[chIdx]['pgDate'] &&
                        value.arrCurrentSesseion[chIdx]['startTime'] &&
                        value.arrCurrentSesseion[chIdx]['endTime'] && (
                          <p className={classes.programTime}>{`${moment(
                            `${value.arrCurrentSesseion[chIdx]['pgDate'].substr(0, 4)}-${value.arrCurrentSesseion[chIdx]['pgDate'].substr(
                              4,
                              2,
                            )}-${value.arrCurrentSesseion[chIdx]['pgDate'].substr(6, 2)}`,
                          ).format('YYYY-MM-DD ')}, ${value.arrCurrentSesseion[chIdx]['startTime']} ~ ${
                            value.arrCurrentSesseion[chIdx]['endTime']
                          }`}</p>
                        )}
                      {value.arrCurrentSesseion[chIdx]['place'] && value.arrCurrentSesseion[chIdx]['room'] && (
                        <p
                          className={classes.programPlace}
                        >{`${value.arrCurrentSesseion[chIdx]['place']}, ${value.arrCurrentSesseion[chIdx]['room']} `}</p>
                      )}
                    </div>

                    {this.renderProgramDetails(value.arrCurrentSesseion[chIdx]['pgTitle'])}
                  </>
                )}
              </div>
            );
          }}
        </MainContext.Consumer>
      </MainProvider>
    );
  }

  renderChairman = () => {
    const p = groupBy(this.state.pgmDetail, 'title');

    return (
      this.state.pgmDetail.length > 0 &&
      p['Chairperson']
        .sort(function (a, b) {
          return a.order > b.order ? 1 : -1;
        })
        .map((c, idx) => {
          // console.log(c, 'ccccccc');
          const comma = idx < p['Chairperson'].length - 1 ? ', ' : '';
          return (
            <div
              key={'chairman-' + idx}
              style={{ float: 'left', marginRight: 3, textDecoration: 'underline', cursor: 'pointer' }}
              onClick={() => this.goFaculty(c)}
            >
              {this.props.program.isEng === true ? <>{c.nameEng + comma}</> : <>{c.nameKor + comma}</>}
              {/* {c.nameKor + comma} */}
            </div>
          );
        })
    );
  };
  renderPanel = () => {
    const p = groupBy(this.state.pgmDetail, 'title');
    const dp = p['Panel'];
    return (
      <TableRow key={'panels'} style={!dp ? { display: 'none' } : { display: 'table-row' }}>
        <TableCell component={'th'} style={{ width: '20%', padding: this.state.matches ? '0 10px' : '0.3em 1em' }}>
          {'Panel'}
        </TableCell>
        <TableCell style={{ width: '80%', padding: this.state.matches ? 0 : '0.3em 1em' }} colspan={2}>
          {/*<div>*/}
          {this.state.pgmDetail.length > 0 &&
            p['Panel'] &&
            p['Panel']
              .sort(function (a, b) {
                return a.order > b.order ? 1 : -1;
              })
              .map((c, idx) => {
                const comma = idx < p['Panel'].length - 1 ? ', ' : '';
                return (
                  <div
                    key={'panel-' + idx}
                    style={{ float: 'left', marginRight: 3, textDecoration: 'underline', cursor: 'pointer' }}
                    onClick={() => this.goFaculty(c)}
                  >
                    {this.props.program.isEng === true ? <>{c.nameEng + comma}</> : <>{c.nameKor + comma}</>}
                    {/* {c.presenter + comma} */}
                  </div>
                );
              })}
          {/*</div>*/}
        </TableCell>
      </TableRow>
    );
  };
  renderExam = () => {
    const p = groupBy(this.state.pgmDetail, 'title');
    const dp = p['Examiner'];
    return (
      <TableRow key={'Examiner'} style={!dp ? { display: 'none' } : { display: 'table-row' }}>
        <TableCell component={'th'} style={{ width: '20%', padding: '0.3em 1em' }}>
          {'Examiner'}
        </TableCell>
        <TableCell style={{ width: '50%', padding: '0.3em 1em' }} colspan={2}>
          {/*<div>*/}
          {this.state.pgmDetail.length > 0 &&
            p['Examiner'] &&
            p['Examiner'].map((c, idx) => {
              const comma = idx < p['Examiner'].length - 1 ? ', ' : '';
              return (
                <div
                  key={'Examiner-' + idx}
                  style={{ float: 'left', marginRight: 3, textDecoration: 'underline', cursor: 'pointer' }}
                  onClick={() => this.goFaculty(c)}
                >
                  {c.presenter + comma}
                </div>
              );
            })}
          {/*</div>*/}
        </TableCell>
      </TableRow>
    );
  };

  renderNoneLive() {
    const { classes, program } = this.props;
    const pgTitle = program.sessionTitle ? program.sessionTitle : program.title ? program.title : program.pgTitle ? program.pgTitle : '';

    return (
      <div className={classes.modalDiv}>
        {program && (
          <>
            <div>
              <div className={classes.titleVodDiv}>
                <p className={classes.sessionTitle}>{pgTitle}</p>
                {program.vod && (
                  <Chip
                    size="small"
                    label="VOD"
                    style={{ backgroundColor: '#9ccc65', color: 'white', fontSize: '1em', marginLeft: '1em' }}
                    onClick={() => {
                      this.openVODDialog(program);
                    }}
                  />
                )}
              </div>
              <p className={classes.subtitle}>{program.pgSub ? program.pgSub : program.session.title ? program.session.title : ''}</p>
              {program.pgDate ? (
                <p className={classes.programTime}>{`${moment(
                  `${program.pgDate.substr(0, 4)}-${program.pgDate.substr(4, 2)}-${program.pgDate.substr(6, 2)}`,
                ).format('YYYY-MM-DD ')}, ${program.startTime} ~ ${program.endTime}`}</p>
              ) : program.session.date ? (
                <p className={classes.programTime}>{`${program.session.date}, ${program.session.startAt} ~ ${program.session.endAt}`}</p>
              ) : null}
              {program.place && program.room ? (
                <p className={classes.programPlace}>{`${program.place}, ${program.room} `}</p>
              ) : (
                <p className={classes.programPlace}>{`${program.place}, ${program.channel}`}</p>
              )}
            </div>
            {this.renderProgramDetails(pgTitle)}
          </>
        )}
      </div>
    );
  }

  goFaculty = (data) => {
    console.log(data);
    if (data) {
      axios
        .get(`${FACULTY_API_URL}/faculty/info?eventId=${EVENT_ID}&id=${EVENT_ID}_${data.presenterEmail}`)
        .then((response) => {
          if (response.data && response.data.Item) {
            this.setState({ facultyInfo: response.data.Item, isFacultyDialogOpen: true });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  renderProgramDetails(pgTitle) {
    const { classes, isLive } = this.props;
    const detail = isLive ? this.state.pgmDetail : this.props.detail;
    // console.log('pgmDetail : ', detail || null);
    // console.log('live_hospital: ', detail[0]?.live_hospital)
    if (detail && detail.length > 0) {
      return (
        <div style={{ width: '100%' }}>
          {detail && detail.length > 0 && (
            <div style={{ width: '100%' }}>
              <Table className={classes.speakerTable} speakerTable>
                <TableBody>
                  <TableRow key={'chairman'}>
                    <TableCell component={'th'} style={{ width: '20%', padding: this.state.matches ? '0 10px' : '0.3em 1em' }}>
                      {'Chairperson(s)'}
                    </TableCell>
                    <TableCell style={{ width: '80%', padding: this.state.matches ? 0 : '0.3em 1em' }} colspan={2}>
                      {this.state.pgmDetail && this.renderChairman()}
                    </TableCell>
                  </TableRow>
                  {this.renderPanel()}
                  {this.renderExam()}
                  {/* eslint-disable-next-line */}
                  {detail.map((d, idx) => {
                    const speaker =
                      d.title !== 'Chairperson' && d.title !== 'Panel' ? (this.props.program.isEng === true ? d.nameEng : d.nameKor) : '';
                    if (d.title !== 'Chairperson' && d.title !== 'Panel' && d.title !== 'Examiner') {
                      return (
                        <React.Fragment key={`speaker-row-${idx}`}>
                          <TableRow>
                            <TableCell component={'th'} style={{ width: '20%', padding: this.state.matches ? '0 10px' : '1em' }}>
                              {d.title}
                            </TableCell>
                            <TableCell style={{ width: '50%', padding: this.state.matches ? 0 : '1em' }}>
                              <span
                                style={!d.Email ? { cursor: 'none' } : { cursor: 'pointer' }}
                                // onClick={() => this.getFacultyData(d.Email)}
                              >
                                {d.contents}
                              </span>
                            </TableCell>
                            <TableCell style={{ width: '30%', padding: '1em' }}>
                              <div
                                onClick={() => this.goFaculty(d)}
                                dangerouslySetInnerHTML={{ __html: speaker }}
                                style={{ textDecoration: 'underline', cursor: 'pointer' }}
                              />

                              <Grid container justifyContent="flex-start" item xs={12} style={{ fontSize: 'small', paddingTop: '5px' }}>
                                {this.props.program.isEng === true ? (
                                  <>
                                    {d.posEng && <span>{d.posEng}</span>}
                                    {d.country && d.posEng && d.country !== '.' && <span>,</span>}
                                    {d.country && <span>&nbsp;&nbsp;{d.country}</span>}
                                    {!d.country && d.posEng && <span>,&nbsp;Korea</span>}
                                  </>
                                ) : (
                                  <>
                                    {!d.country && d.posKor && <span>{d.posKor}</span>}
                                    {d.country && d.posEng && <span>{d.posEng}</span>}
                                    {d.country && d.posEng && <span>,</span>}
                                    {d.country && <span>&nbsp;&nbsp;{d.country}</span>}
                                  </>
                                )}
                              </Grid>
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      );
                    }
                  })}
                </TableBody>
              </Table>
            </div>
          )}
        </div>
      );
    }
  }

  render() {
    const { isLive } = this.props;

    return (
      <>
        {isLive ? this.renderLive() : this.renderNoneLive()}

        {/* Faculty Dialog */}
        {/*<FacultyDetail*/}
        {/*  open={this.state.isFacultyDialogOpen}*/}
        {/*  onClose={this.closeFacultyDialog.bind(this)}*/}
        {/*  disableBackdrop={false}*/}
        {/*  selectedData={this.state.facultyInfo}*/}
        {/*/>*/}

        {/* Faculty Dialog */}
        <FacultyDetail
          open={this.state.isFacultyDialogOpen}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
              this.closeFacultyDialog();
            }
          }}
          // onClose={this.closeFacultyDialog.bind(this)}
          // disableBackdrop={false}
          selectedData={this.state.facultyInfo}
        />

        <PgmVodDialog
          open={this.state.pgmVodDialog}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
              this.setState({ pgmVodDialog: false });
            }
          }}
          // onClose={() => this.setState({ pgmVodDialog: false })}
          // disableBackdrop={false}
          vodId={this.state.vodId}
        />
      </>
    );
  }
}

export default withStyles(styles, { withTheme: true })(ProgramDetail);
